import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Library } from 'lucide-react';
import { fmt, Spinner, ErrorBanner, PaginationBar, DynamicTable, UNAVAILABLE } from '../components/ReportTableKit';

const API = process.env.REACT_APP_BACKEND_URL;

const TABS = [
  { key: 'catalog', label: 'Digital Catalog', endpoint: 'digital-catalog-api', totalKey: 'total', what: 'Digital Catalog' },
  { key: 'tracker', label: 'Session Attribute Tracker', endpoint: 'session-attribute-tracker', totalKey: 'totalRecords', what: 'Session Attribute Tracker' },
];

function CatalogTab({ tab }) {
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({ total: 0, last_page: 1 });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const PER = 50;

  const fetchData = useCallback(async (p) => {
    setLoading(true); setErr(null);
    try {
      const r = await axios.get(`${API}/api/lup/v2/report/${tab.endpoint}`, { params: { page: p, per_page: PER }, withCredentials: true });
      setRows(r.data?.data || []);
      setMeta({ total: r.data?.[tab.totalKey] || 0, last_page: r.data?.last_page || 1 });
      setPage(r.data?.current_page || p);
    } catch (e) {
      setErr(UNAVAILABLE(tab.what)); setRows([]); setMeta({ total: 0, last_page: 1 });
    } finally { setLoading(false); }
  }, [tab.endpoint, tab.totalKey, tab.what]);

  useEffect(() => { fetchData(1); }, [fetchData]);

  return (
    <div className="table-container" data-testid={`catalog-${tab.key}-tab`}>
      {loading ? <Spinner /> : err ? <ErrorBanner message={err} testId={`catalog-${tab.key}-error`} /> : rows.length === 0 ?
        <div className="empty-state"><h3>No records found</h3><p>This feed is currently empty.</p></div> : (<>
          <div className="table-header"><span className="table-title">{tab.label}</span><span className="table-count" style={{ marginLeft: 8 }}>({fmt(meta.total)} rows)</span></div>
          <DynamicTable rows={rows} testId={`catalog-${tab.key}-table`} />
          <PaginationBar page={page} totalPages={meta.last_page} total={meta.total} perPage={PER} onPage={p => fetchData(p)} testId={`catalog-${tab.key}-pagination`} />
        </>)}
    </div>
  );
}

export default function InsightsCubeCatalog() {
  const [tab, setTab] = useState('catalog');
  return (
    <div data-testid="insights-catalog-page">
      <div className="page-header">
        <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}><Library size={22} color="#4338ca" /> Insights Cube — Catalog</h1>
        <p>Digital Catalog course list and Session Attribute Tracker — sourced live from the LevelUp catalog server.</p>
      </div>
      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #e2e8f0', margin: '0 0 16px' }}>
        {TABS.map(t => (
          <button key={t.key} data-testid={`catalog-tab-${t.key}`} onClick={() => setTab(t.key)}
            style={{ padding: '10px 16px', border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600,
              color: tab === t.key ? '#4338ca' : '#64748b',
              borderBottom: tab === t.key ? '2px solid #4338ca' : '2px solid transparent', marginBottom: -1 }}>
            {t.label}
          </button>
        ))}
      </div>
      {TABS.filter(t => t.key === tab).map(t => <CatalogTab key={t.key} tab={t} />)}
    </div>
  );
}
